import React from "react";

export function getRandomCoinHover() {
    return {
        "--hover-distance": `${0.5 + Math.random() * 3}px`,
        "--hover-duration": `${0.7 + Math.random() * 0.6}s`,
        "--hover-delay": `${Math.random() * 1.2}s`,
    };
}

export default function CollectibleCoin({
                                            id,
                                            src,
                                            className = "",
                                            style,
                                            isCollected,
                                            onCollect,
                                        }) {
    if (isCollected) return null;

    return (
        <img
            src={src}
            alt=""
            className={className}
            style={style}
            onClick={(e) => {
                e.stopPropagation();
                onCollect?.(id, e.currentTarget);
            }}
        />
    );
}